"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BOLD = exports.LIGHT = exports.LARGE = exports.SMALL = exports.BOTTOM = exports.RIGHT = exports.TOP = exports.LEFT = void 0;
const tslib_1 = require("tslib");
const OverlayTrigger_1 = tslib_1.__importDefault(require("../overlay/OverlayTrigger"));
// alignment / position
exports.LEFT = OverlayTrigger_1.default.LEFT;
exports.TOP = OverlayTrigger_1.default.TOP;
exports.RIGHT = OverlayTrigger_1.default.RIGHT;
exports.BOTTOM = OverlayTrigger_1.default.BOTTOM;
// icon size
exports.SMALL = 'small';
exports.LARGE = 'large';
// font weight
exports.LIGHT = 'light';
exports.BOLD = 'bold';
